import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class ContactLookupService
{
    constructor(
        private readonly $apiService: ApiService)
    { }

    Lookup(criteria: LookupCriteria): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth<LookupCriteria, IdValuePair[]>("ILookupService/LookupContacts", criteria);
    }
}
